import { z } from 'zod';
import { eventSchema } from './envelope';

export const AGENDA_ITEM_PUBLISHED_V1 = 'agenda.item.published.v1' as const;

/**
 * Er staat een evenement klaar voor jou (Extra 6, punt 3).
 *
 * Met de ontvangers erin, in stukken zoals bij een bericht en een checklist: `notifications`
 * schrijft de inboxregels en kan een doelgroep niet zelf uitrekenen (ADR-0021). `agenda` heeft die
 * lijst op dat moment toch al in handen - hij schrijft hem ook naar `item_recipient`.
 *
 * Alleen bij **publiceren**, niet bij aanmaken: een concept is iets van de opsteller. En niet bij
 * annuleren: dat is een tweede soort melding met een eigen tekst, en die hoort bij Stap 14
 * (inplannen), waar ook het verzetten van een tijdstip thuishoort.
 */
export const agendaItemPublishedV1Schema = eventSchema({
  itemId: z.guid(),
  title: z.string(),
  /** Wanneer het begint, zodat een melding "donderdag 9:00" kan zeggen zonder tweede aanroep. */
  startsAt: z.string().datetime(),
  recipientIds: z.array(z.guid()),
});
export type AgendaItemPublishedV1 = z.infer<typeof agendaItemPublishedV1Schema>;
